// extracted by mini-css-extract-plugin
export var deleteModal = "_eu-0";